import React from 'react';
import { ConfigProvider, theme } from 'antd';

// Palette écosystème Tilmicode (voir PRODUCT.md §Design Principles 4).
const AI_BUILDER_PRIMARY = '#2D9CC9';
const AI_BUILDER_ACCENT = '#8BBE1E';
const AI_BUILDER_INK = '#031323';

export interface AIBuilderThemeProps {
  children: React.ReactNode;
}

const ChatSurface: React.FC<AIBuilderThemeProps> = ({ children }) => {
  const { token } = theme.useToken();
  return (
    <div
      style={{
        background: token.colorPrimaryBg,
        border: `1px solid ${token.colorPrimaryBorder}`,
        borderRadius: token.borderRadiusLG,
        padding: token.paddingLG,
      }}
    >
      {children}
    </div>
  );
};

const AIBuilderTheme: React.FC<AIBuilderThemeProps> = ({ children }) => (
  <ConfigProvider
    theme={{
      token: {
        colorPrimary: AI_BUILDER_PRIMARY,
        colorInfo: AI_BUILDER_PRIMARY,
        colorSuccess: AI_BUILDER_ACCENT,
        colorTextBase: AI_BUILDER_INK,
        colorTextPlaceholder: 'rgba(3, 19, 35, 0.65)',
        borderRadius: 14,
        borderRadiusLG: 20,
        fontSize: 15,
      },
      components: {
        Button: { controlHeight: 44 },
        Input: { controlHeight: 44 },
      },
    }}
  >
    <ChatSurface>{children}</ChatSurface>
  </ConfigProvider>
);

export default AIBuilderTheme;
